import type { AttentionSummary } from "./types";

export interface ApprovalTransport { at: number; phase: "sending" | "sent" }
export const APPROVAL_READBACK_GRACE_MS = 20_000;

/** Preserve exact thread status. Company-wide busy is never revision proof. */
export function reconcileApprovalProgress(attention: Record<string, AttentionSummary>,
  pending: Map<string, ApprovalTransport>, dismissed: Map<string, number>, now: number) {
  return Object.fromEntries(Object.entries(attention).map(([companyId, summary]) => {
    const items = summary.items.filter(item => {
      const key = `${companyId}:${item.threadId}`, at = dismissed.get(key);
      if (at === undefined) return true;
      if (now - at < APPROVAL_READBACK_GRACE_MS) return false;
      dismissed.delete(key); return true;
    }).map(item => {
      const { approvalPending: _local, ...server } = item;
      const key = `${companyId}:${item.threadId}`, transport = pending.get(key);
      if (!transport) return server;
      if (server.status === "resolved" || server.stage === "delivered"
        || (transport.phase === "sent" && (server.runtimeState !== "needs_approval" || now - transport.at >= APPROVAL_READBACK_GRACE_MS))) {
        pending.delete(key); return server;
      }
      return { ...server, approvalPending: transport.phase };
    });
    return [companyId, { ...summary, items, count: items.length }];
  }));
}
